/* eslint-disable func-style */

/**
 * Преобразование строки в массив ключей
 */
function _keyToArray(path: string) {
  let key = path.trim();
  if (key === '') {
    return [];
  }
  key = key.replace(/\[(\w+)\]/g, '.$1');
  key = key.replace(/^\./, '');
  return key.split('.');
}

/**
 * Получение значения свойства объекта
 * @param {Object} obj
 * @param {String} path Путь пропса ('prop.child[0].child')
 * @returns {*|undefined}
 */
export function getProp(obj: any, path: string): unknown {
  const keyParts = _keyToArray(path);
  let nestedVar = obj;

  while (keyParts.length > 0) {
    const childKey = keyParts.shift();
    const allowed = typeof childKey !== 'undefined' && nestedVar.hasOwnProperty(childKey);

    if (allowed && nestedVar[childKey] !== undefined) {
      nestedVar = nestedVar[childKey];
    } else {
      return undefined;
    }
  }

  return nestedVar;
}

/**
 * Установка значения свойства объекта
 * @param {Object} obj
 * @param {String} path Строка пути пропса ('prop.child[0].child')
 * @param {*} value Присваиваемое значение
 */
export function setProp<V = unknown>(obj: any, path: string, value: V) {
  if (typeof obj !== 'object' || typeof path !== 'string') {
    return;
  }

  const keyParts = _keyToArray(path);

  for (let i = 0; i < keyParts.length; i++) {
    const p = keyParts[i];
    if (i === keyParts.length - 1) {
      obj[p] = value;
      break;
    }
    if (typeof obj[p] !== 'object') {
      obj[p] = {};
    }
    obj = obj[p];
  }
}
